<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <div class="dataContainer">
      <template v-if="showPranesimasVeiksmas">
        <h3 class="mb-0 text-inline">
          Veiksmas<el-need
            v-if="!pranesimasReadonly && changePranesimasVeiksmas"
          />
        </h3>
        <v-row class="mb-5" v-if="changePranesimasVeiksmas">
          <v-col cols="12" md="12">
            <el-radio-group
              inline
              class="my-0"
              label="Veiksmas"
              tooltip="Hipoteka. Dokumentas. Veiksmas. "
              :items="pranesimasVeiksmas"
              :readonly="pranesimasReadonly"
              v-model="formData.obj_veiksmas"
            />
          </v-col>
        </v-row>
        <v-row class="mb-5" v-if="!changePranesimasVeiksmas">
          <v-col cols="12" md="12">
            {{ pranesimasVeiksmasText }}
          </v-col>
        </v-row>
      </template>

      <template v-if="showPerduodamas">
        <v-row class="mt-2 mb-5">
          <v-col cols="12" md="12">
            <div class="v-label theme--light">
              {{ perduodamasKreditoriuiText }}
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-if="pranesimasRusisTitle">
        <h3 class="mb-0 text-inline">{{ pranesimasRusisTitle }}</h3>

        <v-row class="mb-5">
          <v-col cols="12" md="8">
            <v-row no-gutters>
              <v-col
                v-for="item in filterRusisNormal"
                :key="item.key"
                cols="12"
                md="6"
              >
                <el-checkbox
                  :label="pranesimasRusisLabel[item.key]"
                  :tooltip="pranesimasRusisLabel[`${item.key}Tooltip`]"
                  :readonly="rusisReadonly(item)"
                  v-model="formData.obj_rusys[item.key]"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row no-gutters>
              <v-col
                v-for="item in filterRusisBold"
                :key="item.key"
                cols="12"
                md="12"
              >
                <el-checkbox
                  :label="pranesimasRusisLabel[item.key]"
                  class="bold"
                  :tooltip="pranesimasRusisLabel[`${item.key}Tooltip`]"
                  :readonly="rusisReadonly(item)"
                  :disabled="rusisDisabled(item)"
                  v-model="formData.obj_rusys[item.key]"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>

      <template v-if="!pageloading">
        <h3 v-if="showDuomenysTitle" class="mb-3 text-inline">
          {{ dokumentoDuomenysTitle }}
        </h3>

        <v-row v-if="showPagrindas">
          <v-col cols="12" md="12">
            <el-autocomplete
              v-if="showPagrindasKlasif"
              need
              :items="pagrindasItems"
              itemvalue="value"
              itemtext="text"
              :label="pagrindasText.pagrindas"
              :tooltip="
                `${pagrindasText.tooltipPrefix}${pagrindasText.pagrindas}`
              "
              :readonly="pranesimasReadonly"
              v-model="formData.zug_pagrindas_kla_id"
            />
          </v-col>
          <v-col cols="12">
            <el-textarea
              :need="!isSavitarna"
              :label="pagrindasAprasymasLabel"
              :tooltip="
                `${pagrindasText.tooltipPrefix}${pagrindasText.aprasymas}`
              "
              :counter="2000"
              :readonly="pranesimasReadonly"
              v-model="formData.zug_pagrindas_aprasymas"
            />
          </v-col>
        </v-row>
        <v-row>
          <template v-if="showDokumentoNumeris || showDokumentoVieta">
            <v-col cols="12" md="6" v-if="showDokumentoNumeris">
              <el-text-field
                need
                label="Dokumento numeris"
                :tooltip="`${tooltipPrefix}Dokumentas. Dokumento numeris`"
                :counter="50"
                :readonly="dokumentoNumerisReadonly"
                v-model="formData.obj_dokumento_numeris"
                autofocus
              />
            </v-col>
            <v-col cols="12" md="6" v-if="showDokumentoVieta">
              <el-text-field
                need
                label="Dokumento vieta"
                :tooltip="`${tooltipPrefix}Dokumentas. Dokumento vieta`"
                :counter="50"
                :readonly="pranesimasReadonly"
                v-model="formData.obj_dokumento_vieta"
              />
            </v-col>
          </template>
          <template v-if="showDokumentoData || showDokumentoLaikas">
            <v-col cols="12" md="6" v-if="showDokumentoData">
              <el-date-picker
                need
                label="Dokumento data"
                :tooltip="`${tooltipPrefix}Dokumentas. Dokumento data`"
                :readonly="dokumentoDataReadonly"
                v-model="formData.obj_dokumento_data"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="showDokumentoLaikas">
              <el-time-picker
                need
                label="Dokumento laikas"
                :tooltip="`${tooltipPrefix}Dokumentas. Dokumento laikas`"
                :readonly="dokumentoLaikasReadonly"
                v-model="formData.obj_dokumento_laikas"
              />
            </v-col>
          </template>
        </v-row>
      </template>
    </div>

    <hipoteka-istorija duomenys="pranesimo-duomenys" />

    <v-footer class="form-footer">
      <el-button
        v-if="!pranesimasReadonly"
        primary
        @click.native="saveData()"
        :loading="loading"
        >Saugoti</el-button
      >
      <el-button
        v-if="!pranesimasReadonly"
        @click.native="cancelData()"
        :loading="loading"
        >Atšaukti</el-button
      >
      <v-spacer></v-spacer>
      <el-button
        v-if="!pranesimasReadonly"
        primary
        @click.native="checkErrorsClick()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from './hipotekaMap'
import busena from '../../mixins/busena'
import userRole from '../../mixins/userRole'
import unsavedData from '../../mixins/unsavedData'
import checkErrors from '../../mixins/checkErrors'
import HipotekaIstorija from './istorija/HipotekaIstorija'

export default {
  name: 'HipotekaPranesimas',
  components: {
    HipotekaIstorija,
  },
  mixins: [busena, userRole, unsavedData, checkErrors],
  props: {
    readonlyForm: { type: Boolean, default: false },
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      formData: {
        obj_pageidauja_ireg: true,
        obj_dokumento_numeris: null,
        obj_dokumento_data: null,
        obj_dokumento_laikas: null,
        obj_rusys: {},
      },
      pagrindas: [],
      loading: true,
      pageloading: true,
      mokestis: 8.0,

      pranesimasVeiksmas: [
        {
          label: 'Sudarymas',
          tooltip: 'Hipoteka. Dokumentas. Veiksmas. Sudarymas',
          value: 1,
        },
        {
          label: 'Teikimas',
          tooltip: 'Hipoteka. Dokumentas. Veiksmas. Teikimas',
          value: 2,
        },
      ],
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'objektasVeiksmas',
      'objektasSalyginis',
      'perduodamasKreditoriui',
      'dokumentasSavitarna',
      'objektasSavitarna',
      'hipotekaReadonly',
      'appSavitarna',
    ]),
    pranesimasRusis() {
      return [
        {
          key: 'maksimalus',
          value: false,
        },
        {
          key: 'paprastas',
          value: false,
        },
        {
          key: 'jungtinis',
          value: false,
        },
        {
          key: 'svetimas',
          value: false,
        },
        {
          key: 'bendras',
          value: false,
        },
        {
          key: 'imones',
          value: false,
          hide: this.hideRusisImone,
        },
        {
          key: 'salyginis',
          value: false,
          bold: true,
        },
        {
          key: 'pareikstinis',
          value: false,
          bold: true,
          hide: this.hidePareikstinis,
        },
      ]
    },
    pranesimasRusisKey() {
      return Object.keys(HipotekaMap['pranesimasRusis']).find(e =>
        this.hipotekaTipas.includes(e)
      )
    },
    pranesimasRusisTitle() {
      const key = this.pranesimasRusisKey
      return key ? HipotekaMap['pranesimasRusis'][key].title : null
    },
    pranesimasRusisLabel() {
      const key = this.pranesimasRusisKey
      return key ? HipotekaMap['pranesimasRusis'][key].labels : null
    },
    filterRusisNormal() {
      return this.pranesimasRusis.filter(item => {
        return !item.bold && !item.hide
      })
    },
    filterRusisBold() {
      return this.pranesimasRusis.filter(item => {
        return item.bold && !item.hide
      })
    },
    pranesimasReadonly() {
      return this.hipotekaReadonly || this.readonlyForm
    },
    isPareikstinis() {
      return this.formData.obj_rusys.pareikstinis
    },
    hidePareikstinis() {
      return this.isSavitarna && !this.role(['EL_JA']) && !this.isPareikstinis
    },
    showPranesimasVeiksmas() {
      return this.roleOr([
        'DT_notaras',
        'DT_notaro_padejejas',
        'DT_notaro_atstovas',
      ])
    },
    changePranesimasVeiksmas() {
      return (
        (this.isRengiamas || this.isGrazintas) && this.showPranesimasVeiksmas
      )
    },
    pranesimasVeiksmasText() {
      let veiksmas = this.pranesimasVeiksmas.find(
        e => e.value === this.formData.obj_veiksmas
      )
      return veiksmas ? veiksmas.label : ''
    },
    dokumentoDuomenysTitle() {
      if (this.isVykdomasis) {
        if (this.isPakeitimas) {
          return 'NVĮ pakeitimo dokumento duomenys'
        }
        if (this.isPabaiga) {
          return 'NVĮ panaikinimo dokumento duomenys'
        }
        return 'NVĮ dokumento duomenys'
      }
      if (this.isPabaiga) {
        return 'Pabaigos dokumento duomenys'
      }
      if (this.isPakeitimas) {
        return 'Pakeitimo dokumento duomenys'
      }
      return 'Dokumento duomenys'
    },
    showPagrindas() {
      return (
        this.hipotekaTipas.includes('pakeitimas') ||
        this.hipotekaTipas.includes('isigaliojimas') ||
        this.hipotekaTipas.includes('pabaiga') ||
        this.hipotekaTipas.includes('panaikinimas') ||
        this.hipotekaTipas.includes('pageidavimas') ||
        this.hipotekaTipas.includes('atsaukimas') ||
        this.hipotekaTipas.includes('archyvas')
      )
    },
    showPagrindasKlasif() {
      return (
        !this.hipotekaTipas.includes('priverstinis') ||
        this.hipotekaTipas.includes('pakeitimas') ||
        this.hipotekaTipas.includes('archyvas')
      )
    },
    pagrindasItems() {
      return this.pagrindas
        ? this.pagrindas.map(item => {
            return item
          })
        : []
    },
    pagrindasText() {
      const key = Object.keys(HipotekaMap['pranesimasPagrindas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      if (!key) {
        return []
      }
      const key2 = Object.keys(
        HipotekaMap['pranesimasPagrindas'][key]
      ).find(e => this.hipotekaTipas.includes(e))
      if (!key2) {
        return []
      }
      return HipotekaMap['pranesimasPagrindas'][key][key2]
    },
    pagrindasAprasymasLabel() {
      return this.isSavitarna ? 'Aprašymas' : this.pagrindasText.aprasymas
    },
    showDokumentoData() {
      return (
        !this.isSavitarna ||
        !this.isSudarymas ||
        this.formData.obj_dokumento_data !== null
      )
    },
    showDokumentoLaikas() {
      return (
        !this.isPabaiga &&
        !this.isSutartis &&
        (!this.isSavitarna ||
          !this.isSudarymas ||
          this.formData.obj_dokumento_laikas !== null)
      )
    },
    showDokumentoVieta() {
      return (
        this.isPradzia &&
        !this.isSutartis &&
        !this.isVykdomasis &&
        (!this.isSavitarna || !this.isSudarymas)
      )
    },
    showDokumentoNumeris() {
      return !this.isSavitarna || !this.isSudarymas
    },
    showDuomenysTitle() {
      return (
        this.showPagrindas ||
        this.showDokumentoNumeris ||
        this.showDokumentoVieta ||
        this.showDokumentoData ||
        this.showDokumentoLaikas
      )
    },
    isPakeitimas() {
      return this.hipotekaTipas.includes('pakeitimas')
    },
    isPradzia() {
      return (
        this.hipotekaTipas.includes('sandoris') ||
        this.hipotekaTipas.includes('nustatymas') ||
        this.hipotekaTipas.includes('atlikimas') ||
        this.hipotekaTipas.includes('teikimas')
      )
    },
    isPabaiga() {
      return (
        this.hipotekaTipas.includes('pabaiga') ||
        this.hipotekaTipas.includes('panaikinimas')
      )
    },
    isArchyvas() {
      return this.hipotekaTipas.includes('archyvas')
    },
    isAdresas() {
      return (
        this.hipotekaTipas.includes('adresas') &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    isSandoris() {
      return this.hipotekaTipas.includes('sandoris')
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isVykdomasis() {
      return this.hipotekaTipas.includes('vykdomasis')
    },
    isSutartinisIkeitimas() {
      return this.hipotekaTipas.includes('sutartinis-ikeitimas')
    },
    tooltipPrefix() {
      return `${
        this.isSavitarna
          ? (this.isSudarymas ? 'Savitarna. Sudarymas. ' : '') +
            (this.isTeikimas ? 'Savitarna. Teikimas. ' : '')
          : ''
      }${this.isSutartis ? 'Sutartis. ' : 'Hipoteka. '}`
    },
    hideRusisImone() {
      return this.isSutartinisIkeitimas
    },
    isSudarymas() {
      return this.objektasVeiksmas === 1
    },
    isTeikimas() {
      return this.objektasVeiksmas === 2
    },
    originSavitana() {
      return this.formData.origin_savitarna
    },
    isSavitarna() {
      return this.appSavitarna || this.originSavitana
    },
    dokumentoNumerisReadonly() {
      return this.pranesimasReadonly || (this.isSavitarna && this.isSudarymas)
    },
    dokumentoDataReadonly() {
      return this.pranesimasReadonly || (this.isSavitarna && this.isSudarymas)
    },
    dokumentoLaikasReadonly() {
      return this.pranesimasReadonly || (this.isSavitarna && this.isSudarymas)
    },
    showPerduodamas() {
      return this.objektasSavitarna
    },
    perduodamasKreditoriuiText() {
      if (this.isSutartis) {
        return 'Pranešimas apie sutartį savitarnoje'
      }
      if (this.isPabaiga) {
        return 'Pranešimas apie pabaigą savitarnoje'
      }
      if (this.objektasVeiksmas === 1) {
        switch (this.perduodamasKreditoriui) {
          case 1:
            return 'Sudarytas savitarnoje IT priemonėmis, kai įkeitimo objektas perduodamas kreditoriui'
          case 2:
            return 'Sandoris sudarytas savitarnoje IT priemonėmis, kai įkeitimo objektas perduodamas trečiajam asmeniui'
          case 0:
            return 'Sandoris sudarytas savitarnoje IT priemonėmis, kai Įkeitimo objektas lieka įkaito davėjui'
        }
      } else {
        switch (this.perduodamasKreditoriui) {
          case 1:
            return 'Pranešimas apie sandorį savitarnoje, kai įkeitimo objektas perduodamas kreditoriui'
          case 2:
            return 'Pranešimas apie sandorį savitarnoje, kai įkeitimo objektas perduodamas trečiajam asmeniui'
          case 0:
            return ' Pranešimas apie sandorį savitarnoje, kai Įkeitimo objektas lieka įkaito davėjui'
        }
      }
      return ''
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`objektas/${this.objektasID}/pranesimoduomenys`)
        .then(res => {
          this.formData = res.data.pranesimo_duomenys
          this.pagrindas = res.data.pagrindas

          if (this.formData.obj_pageidauja_ireg === null) {
            this.formData.obj_pageidauja_ireg = true
          }

          if (this.pagrindasItems.length === 1) {
            this.formData.zug_pagrindas_kla_id = this.pagrindasItems[0].value
          }

          if (
            !this.showPranesimasVeiksmas &&
            this.formData.obj_veiksmas === null
          ) {
            this.formData.obj_veiksmas = 2
          }

          this.initialForm()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData(toRoute, afterSave) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let data = this.formData
          data.obj_id = this.objektasID

          this.$axios
            .post(`objektas/${this.objektasID}/pranesimoduomenys`, data)
            .then(res => {
              this.$store.dispatch(
                'objektasVeiksmas',
                this.formData.obj_veiksmas
              )
              this.$store.dispatch(
                'objektasSalyginis',
                data.obj_rusys.salyginis
              )
              this.$root.$emit(
                'updateDokumentasNr',
                this.formData.obj_dokumento_numeris
              )

              if (toRoute) {
                this.goToRoute()
              } else {
                this.initialForm()
                if (afterSave === 'checkErrors') {
                  this.checkErrors()
                }
              }
              window._VMA.$emit('DATA_OK', 'Duomenys išsaugoti')
              this.$root.$emit('reloadHipotekaTab')
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
          this.$root.$emit('cancelTabNavigation')
        }
      })
    },
    cancelData() {
      this.getData()
    },
    checkErrorsClick() {
      this.saveData(null, 'checkErrors')
    },
    rusisReadonly(item) {
      return (
        this.pranesimasReadonly ||
        (item.key === 'salyginis' && !this.isPradzia) ||
        this.isVykdomasis ||
        this.isPabaiga ||
        this.isArchyvas ||
        this.isAdresas
      )
    },
    rusisDisabled(item) {
      return false //item.key === 'salyginis'
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
</style>
